import { Injectable } from '@angular/core';
import { IValueObject } from '@type_definitions/datatypes';
import { util } from '../util';

export enum CurrencyISO {
  EUR = 'EUR',
  USD = 'USD'
}

/**
 * @ngdoc service
 * @name ga2.shared.services:currencyService
 *
 * @description Information about currencies
 */
@Injectable()
export class CurrencyService {
  private currencyDecimals = {
    ADP: 2,
    AED: 2,
    AFA: 2,
    AFN: 2,
    ALL: 2,
    AMD: 2,
    ANG: 2,
    AOA: 2,
    ARS: 2,
    ATS: 2,
    AUD: 2,
    AWG: 2,
    AZM: 2,
    AZN: 2,
    BAM: 2,
    BBD: 2,
    BDT: 2,
    BEF: 2,
    BGL: 2,
    BGN: 2,
    BHD: 3,
    BIF: 0,
    BMD: 2,
    BND: 2,
    BOB: 2,
    BRL: 2,
    BSD: 2,
    BSF: 2,
    BTC: 2,
    BTN: 2,
    BWP: 2,
    BYN: 0,
    BYR: 0,
    BZD: 2,
    CAD: 2,
    CDF: 2,
    CDZ: 2,
    CHF: 2,
    CLF: 2,
    CLP: 0,
    CNY: 2,
    COP: 2,
    CRC: 2,
    CUC: 2,
    CUP: 2,
    CVE: 0,
    CYP: 2,
    CZK: 2,
    DEM: 2,
    DJF: 0,
    DKK: 2,
    DOP: 2,
    DZD: 2,
    ECS: 2,
    EEK: 2,
    EGP: 2,
    ERN: 2,
    ESP: 2,
    ETB: 2,
    EUR: 2,
    FIM: 2,
    FJD: 2,
    FKP: 2,
    FRF: 2,
    GBP: 2,
    GEL: 2,
    GGP: 2,
    GHC: 2,
    GHS: 2,
    GIP: 2,
    GMD: 2,
    GNF: 0,
    GPB: 2,
    GRD: 2,
    GTQ: 2,
    GYD: 2,
    HKD: 2,
    HNL: 2,
    HRK: 2,
    HTG: 2,
    HUF: 2,
    IDR: 2,
    IEP: 2,
    ILS: 2,
    IMP: 2,
    INR: 2,
    IQD: 3,
    IRR: 2,
    ISK: 0,
    ITL: 2,
    JEP: 2,
    JMD: 2,
    JOD: 3,
    JPY: 0,
    KES: 2,
    KGS: 2,
    KHR: 2,
    KMF: 0,
    KPW: 2,
    KRW: 0,
    KWD: 3,
    KYD: 2,
    KZT: 2,
    LAK: 2,
    LBP: 2,
    LKR: 2,
    LRD: 2,
    LSL: 2,
    LTL: 2,
    LUF: 2,
    LVL: 2,
    LYD: 3,
    MAD: 2,
    MDL: 2,
    MGA: 1,
    MGF: 2,
    MKD: 2,
    MMK: 2,
    MNT: 2,
    MOP: 2,
    MR: 2,
    MRO: 1,
    MTL: 2,
    MUR: 2,
    MVR: 2,
    MWK: 2,
    MXN: 2,
    MYR: 2,
    MZM: 2,
    MZN: 2,
    NAD: 2,
    NGN: 2,
    NIO: 2,
    NLG: 2,
    NOK: 2,
    NPR: 2,
    NZD: 2,
    OMR: 3,
    PAB: 2,
    PEN: 2,
    PGK: 2,
    PHP: 2,
    PKR: 2,
    PLN: 2,
    PNG: 2,
    PTE: 2,
    PYG: 0,
    QAR: 2,
    RMB: 2,
    ROL: 2,
    RON: 2,
    RSD: 2,
    RUB: 2,
    RUR: 2,
    RWF: 0,
    SAR: 2,
    SBD: 2,
    SCR: 2,
    SDD: 2,
    SDG: 2,
    SEK: 2,
    SGD: 2,
    SHP: 2,
    SIT: 2,
    SKK: 2,
    SLL: 2,
    SOM: 2,
    SOS: 2,
    SRD: 2,
    SRG: 2,
    STD: 2,
    SVC: 2,
    SYP: 2,
    SZL: 2,
    THB: 2,
    TJS: 2,
    TMM: 2,
    TMT: 2,
    TND: 3,
    TOP: 2,
    TPE: 2,
    TRL: 2,
    TRY: 2,
    TTD: 2,
    TWD: 2,
    TZS: 2,
    UAH: 2,
    UGX: 0,
    USD: 2,
    UYU: 2,
    UZS: 2,
    VEB: 2,
    VEF: 2,
    VES: 2,
    VND: 0,
    VUV: 0,
    WST: 2,
    XAF: 0,
    XAG: 2,
    XAU: 2,
    XCD: 2,
    XDR: 2,
    XOF: 0,
    XPF: 0,
    XPT: 2,
    YER: 2,
    YUM: 2,
    ZAR: 2,
    ZMK: 2,
    ZMW: 2,
    ZRZ: 2,
    ZWD: 2,
    ZWL: 2
  };

  constructor() {/***/
  }

  /**
   * @ngdoc method
   * @name ga2.common.service:currencyService#getDecimals
   * @methodOf ga2.common.service:currencyService
   * @description returns the number of decimals to be used for a given currency
   * @param {string} currencyIsoCode The 3-letter iso-code of the currency e.g. EUR for Euro
   * @return The number of digits for a given currency (or default 2 for an unknown currency)
   */

  public getDecimals(currencyIsoCode:string):number {
    const decimals:number = this.currencyDecimals[ currencyIsoCode ];
    return util.notNullOrUndefinedOrEmpty(decimals)? decimals : 2;
  }

  public getMainCurrencies():IValueObject[] {
    return [
      {
        id: CurrencyISO.EUR,
        value: 'Euro'
      },
      {
        id: CurrencyISO.USD,
        value: 'US Dollar'
      }
    ];
  }

}